const HALF_SALE_RATIO = 0.5;
const SALE_RATIO_EPSILON = 0.000000001;

export function getYokraCeilingForSoldDate(soldPropertyDate, yokraCeilings) {
  const soldYear = new Date(soldPropertyDate).getFullYear();
  if (!Number.isFinite(soldYear) || !Array.isArray(yokraCeilings)) return null;

  return yokraCeilings.reduce((result, item) => {
    if (!Number.isFinite(item.year) || !Number.isFinite(item.tikratYokra) || item.year > soldYear) return result;
    if (!result || item.year > result.year) return item;
    return result;
  }, null);
}

export function getPersonalLuxuryExemptionSoldRatio(preCalc) {
  if (!preCalc) return null;
  if (!Number.isFinite(preCalc.totalPropertyCost) || preCalc.totalPropertyCost <= 0) return null;
  if (!Number.isFinite(preCalc.valueActualSoldOfProperty)) return null;

  return preCalc.valueActualSoldOfProperty / preCalc.totalPropertyCost;
}

export function isPersonalLuxuryExemptionPartialSale(preCalc) {
  const soldRatio = getPersonalLuxuryExemptionSoldRatio(preCalc);
  return soldRatio !== null && soldRatio > 0 && soldRatio < 1;
}

export function isPersonalLuxuryExemptionHalfSale(preCalc) {
  const soldRatio = getPersonalLuxuryExemptionSoldRatio(preCalc);
  return soldRatio !== null && Math.abs(soldRatio - HALF_SALE_RATIO) < SALE_RATIO_EPSILON;
}

export function isPersonalLuxuryExemptionCeilingSectionShown(preCalc) {
  if (!preCalc) return false;

  const firstPreCalcPart = Array.isArray(preCalc.preCalcPartsData) ? preCalc.preCalcPartsData[0] : null;
  const yokraCeiling = getYokraCeilingForSoldDate(preCalc.soldPropertyDate, preCalc.yokraCeilings);
  const isOverLuxuryCeiling =
    Number.isFinite(preCalc.totalPropertyCostWithoutZaban) &&
    Boolean(yokraCeiling) &&
    preCalc.totalPropertyCostWithoutZaban > yokraCeiling.tikratYokra;

  return (
    preCalc.isGavaFeatureEnabled === true &&
    preCalc.sellerType === "single" &&
    preCalc.propertyType === "dmm" &&
    preCalc.howPropertyIsSold === "partOfPropertySold" &&
    isPersonalLuxuryExemptionPartialSale(preCalc) &&
    isOverLuxuryCeiling &&
    preCalc.isOnlyProperty === true &&
    Array.isArray(preCalc.preCalcPartsData) &&
    preCalc.preCalcPartsData.length === 1 &&
    firstPreCalcPart &&
    firstPreCalcPart.percentBought === 100 &&
    firstPreCalcPart.wayOfGettingProperty === "purchase" &&
    firstPreCalcPart.isSinglePropertyPtorAllowed === true &&
    firstPreCalcPart.isInheritancePtorAllowed !== true
  );
}

export function shouldConfirmPersonalLuxuryExemptionCeiling(preCalc) {
  return isPersonalLuxuryExemptionPartialSale(preCalc) && !isPersonalLuxuryExemptionHalfSale(preCalc);
}
